import React, { useEffect, useRef, useState } from "react";
import validation from "../../../utilities/validation";
import * as utilities from "../../../utilities/utils";
import {
  EMAILREGEX,
  EMAIL_PLACEHOLDER,
  NUMBER_FORMAT_REGEX,
  PHONE_PLACEHOLDER,
} from "../../../App.config";
import DropdownComponent from "../../../containers/Dropdown";

const AttachmentDescriptionModal = (props) => {
  const initialState = {
    description: {
      value: props.attachmentDescription ? props.attachmentDescription : "",
      error: "",
      ref: useRef(),
      validation: {
        required: true,
      },
      positionCount: 1,
    },
    isSubmitOnce: { value: false },
  };

  const [state, setState] = useState(initialState);

  const handleChanges = (event) => {
    let { name, value, checked, type } = event.target;

    let updatedObj = state[name];
    updatedObj.value = type === "checkbox" ? checked : value;

    if (state.isSubmitOnce.value) {
      FormValidation();
    }

    setState((state) => {
      return {
        ...state,
        [name]: updatedObj,
      };
    });
  };

  const FormValidation = () => {
    for (const property in state) {
      
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        
        let validatedObj = validation(state[property], props.context);

        setState((state) => {
          return {
            ...state,
            [property]: validatedObj,
          };
        });
      }
    }
  };

  const isFormValid = () => {
    let isValid = true;
    for (const property in state) {
      if (
        state[property]?.validation &&
        Object.keys(state[property].validation).length
      ) {
        if (state[property]?.error.length > 0) {
          isValid = false;
        }
      }
    }
    return isValid;
  };

  const onSubmit = () => {
    setState((state) => {
      return {
        ...state,
        isSubmitOnce: utilities.convertIntoObject(true),
      };
    });

    FormValidation();

    if (isFormValid()) {
      props.attachment[props.index].attachmentDescription =
        state.description.value;
      props.setAttachment(props.attachment);
      props.closeRemoveModal();
    } else {
      ///How to get First error in particular step
      let errorObject = [];

      for (const property in state) {
        if (state[property].error)
          errorObject.push({
            name: property,
            label: state[property].label,
            error: state[property].error,
            positionCount: state[property].positionCount,
          });
      }
      errorObject.sort(function (a, b) {
        return a.positionCount - b.positionCount;
      });

      //Setting focus on first error field
       //Setting focus on first error field
       if (state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus) {
        state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.focus();
      } else {
        state[errorObject[0].name] && state[errorObject[0].name].ref && state[errorObject[0].name].ref.current && state[errorObject[0].name].ref.current.setFocus();
      }
    }
  };

  return (
    <div className="modal-dialog modal-dialog-centered" role="document">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title" id="exampleModalLabel">
            {props.context.t(
              "STD-Employer-Statement.form.Attachment.label.text.Add-Description"
            )}
          </h5>
          <button
            type="button"
            className="close"
            data-dismiss="modal"
            aria-label="Close"
            onClick={() => props.closeRemoveModal()}
          >
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div className="modal-body">
          <span>
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <div className="form-group">
                  <label htmlFor="">
                    {props.context.t(
                      "STD-Employer-Statement.form.Attachment.label.text.Description"
                    )}
                    <span size="5" className="error-star">
                      *
                    </span>
                  </label>
                  <div className="form-group">
                    <textarea
                      placeholder={props.context.t(
                        "STD-Employer-Statement.form.Employee-Details.label.PlaceHolder.Common.TypeHere"
                      )}
                      className="form-control"
                      name="description"
                      ref={state.description.ref}
                      value={state.description.value}
                      onChange={handleChanges}
                    />
                    {state.description?.error && (
                      <span className="error">{state.description.error}</span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </span>
        </div>
        <div className="modal-footer">
          <button onClick={onSubmit} type="button" className="btn btn-primary">
            {props.context.t("STD-Employer-Statement.form.Common.Submit")}
          </button>
        </div>
      </div>
    </div>
  );
};
export default AttachmentDescriptionModal;
